<template>
    <div class="approvedIcon" :style="'background-color: ' + color">
        <img class="position-relative" src="../../../../assets/check-icon.svg" alt="check" />
    </div>
</template>
<script>
export default {
    props: {
        color: {
            type: String,
            required: false,
            default: "#3c3843"
        }
    }
};
</script>
<style scoped lang="scss">
.approvedIcon {
    margin: auto;
    width: 30px;
    height: 30px;
    position: relative;
    border-radius: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        width: 50%;
        height: 50%;
        object-fit: contain;
    }
}
</style>



// WEBPACK FOOTER //
// ApprovedIcon.vue?15451ae0